import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VCard,
        [
          _c(
            "div",
            { staticClass: "text-right pa-2" },
            [
              _vm.hideAssignAllTables
                ? _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "outline-primary" },
                      on: {
                        click: function ($event) {
                          return _vm.openAllTempOwner()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("done_all"),
                      ]),
                      _vm._v(
                        _vm._s(_vm.$t("botones.boton_dataset_all_operator"))
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("b-table", {
            staticClass: "text-center",
            style: { "font-size": "11px" },
            attrs: {
              responsive: "",
              hover: "",
              fields: _vm.datasetFields,
              items: _vm.powerbi_dataset,
              "per-page": _vm.pagination.limit,
              "current-page": _vm.pagination.current,
              "show-empty": "",
              busy: _vm.isBusy,
            },
            scopedSlots: _vm._u([
              {
                key: "table-busy",
                fn: function (scope) {
                  return [_c("strong", [_vm._v(_vm._s(_vm.messageLoading))])]
                },
              },
              {
                key: "empty",
                fn: function (scope) {
                  return [_c("strong", [_vm._v(_vm._s(_vm.messageEmptyList))])]
                },
              },
              {
                key: "cell(object_name)",
                fn: function (row) {
                  return [
                    _c("div", { staticClass: "text-left" }, [
                      _c("b", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.changeMetaDataset(row.item, true)
                              },
                            },
                          },
                          [_vm._v(_vm._s(row.item.object_name))]
                        ),
                      ]),
                      _c("br"),
                      _c("a", {
                        domProps: {
                          innerHTML: _vm._s(_vm.composeName(row.item)),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeMetaDataset(row.item, true)
                          },
                        },
                      }),
                    ]),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (row) {
                  return [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isDataOperator(row.item) ||
                              (!_vm.isDataOperator(row.item) &&
                                row.item.environment === "prod"),
                            expression:
                              "isDataOperator(row.item) || (!isDataOperator(row.item) && row.item.environment === 'prod')",
                          },
                        ],
                        staticClass: "ml-1",
                        attrs: {
                          size: "sm",
                          variant: "outline-primary",
                          title: "Update Metadata",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeMetaDataset(row.item, false)
                          },
                        },
                      },
                      [_c("b-icon", { attrs: { icon: "pencil-fill" } })],
                      1
                    ),
                    _vm.isDataOperator(row.item) &&
                    row.item.environment === "prod"
                      ? _c(
                          "b-button",
                          {
                            staticClass: "ml-1",
                            attrs: {
                              size: "sm",
                              variant: "outline-primary",
                              title: "Set Temporal data operator",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openTempOwner(row.item)
                              },
                            },
                          },
                          [_c("b-icon", { attrs: { icon: "people-fill" } })],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isDataOperator(row.item),
                            expression: "isDataOperator(row.item)",
                          },
                        ],
                        staticClass: "ml-1",
                        attrs: {
                          size: "sm",
                          variant: "outline-primary",
                          title: "Sync Dataset",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.syncPowerbiDataset(row.item)
                          },
                        },
                      },
                      [_c("b-icon", { attrs: { icon: "arrow-clockwise" } })],
                      1
                    ),
                  ]
                },
              },
              {
                key: "cell(rol)",
                fn: function (row) {
                  return [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "b-popover",
                            rawName: "v-b-popover.hover.right",
                            value: "Open in Power BI",
                            expression: "'Open in Power BI'",
                            modifiers: { hover: true, right: true },
                          },
                        ],
                        attrs: {
                          id: "'popover-open-pbi-' + " + row.item.dataset_id,
                          size: "sm",
                          variant: "outline-primary",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.onOpenPopoverOpenBI(row.item)
                          },
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isDataOperator(row.item),
                                expression: "isDataOperator(row.item)",
                              },
                            ],
                          },
                          [_vm._v("Data operator")]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isDataOperator(row.item),
                                expression: "!isDataOperator(row.item)",
                              },
                            ],
                          },
                          [_vm._v("viewer")]
                        ),
                      ]
                    ),
                    _c(
                      "b-popover",
                      {
                        ref: "popover",
                        attrs: {
                          target:
                            "'popover-open-pbi-' + " + row.item.dataset_id,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "title",
                              fn: function () {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "close",
                                      attrs: { "aria-label": "Close" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onClosePopoverOpenBI(
                                            row.item
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "d-inline-block",
                                          attrs: { "aria-hidden": "true" },
                                        },
                                        [_vm._v("×")]
                                      ),
                                    ]
                                  ),
                                  _c("span", [_vm._v("PBI Access Link")]),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _c(
                          "b-input-group",
                          { attrs: { size: "sm" } },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value: row.item.access_link,
                                readonly: "",
                              },
                            }),
                            _c(
                              "b-input-group-append",
                              [
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true },
                                      },
                                    ],
                                    attrs: { size: "sm", title: "Copy" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyAccessLink(
                                          row.item.access_link
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: { icon: "clipboard" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-input-group-append",
                              [
                                _c(
                                  "b-button",
                                  {
                                    directives: [
                                      {
                                        name: "b-tooltip",
                                        rawName: "v-b-tooltip.hover",
                                        modifiers: { hover: true },
                                      },
                                    ],
                                    attrs: {
                                      size: "sm",
                                      title: "Open",
                                      href: row.item.access_link,
                                      target: "_blank",
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: { icon: "box-arrow-up-right" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination-vue", {
        attrs: { pagination: _vm.pagination },
        on: { onPage: _vm.changePagina },
      }),
      _c(
        "b-modal",
        {
          attrs: { id: _vm.MODAL_NAME_DATASET, size: "xl", "hide-footer": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isReadonly,
                          expression: "!isReadonly",
                        },
                      ],
                    },
                    [_vm._v("Change dataset metadata")]
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isReadonly,
                          expression: "isReadonly",
                        },
                      ],
                    },
                    [_vm._v("Dataset metadata")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("form-meta-dataset", {
            attrs: {
              item: _vm.data_ds,
              dataset_id: _vm.data_ds ? _vm.data_ds["dataset_id"] : "",
              isChangeRequest: _vm.isReadonly
                ? _vm.ACCESS_TYPE_FLOW.ACCESS
                : _vm.ACCESS_TYPE_FLOW.CHANGE_METADATA,
              readonly: _vm.isReadonly,
              showButtons: !_vm.isReadonly,
            },
            on: { onCloseModal: _vm.onCloseModalDataset },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        { attrs: { "hide-footer": "", id: _vm.MODAL_NAME_OWNER } },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v("Assign temporal operator"),
          ]),
          _c(
            "div",
            { staticClass: "d-block" },
            [
              _c("form-assign-temporal-owner", {
                attrs: { tplToWork: _vm.data_ds, type: "dataset" },
                on: {
                  submitDataset: _vm.assignOwner,
                  cancel: function ($event) {
                    return _vm.$bvModal.hide(_vm.MODAL_NAME_OWNER)
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "b-modal",
        { attrs: { "hide-footer": "", id: _vm.MODAL_NAME_ALL_OWNER } },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v("Assign dataset to temporal operator"),
          ]),
          _c(
            "div",
            { staticClass: "d-block" },
            [
              _c("form-assign-temporal-owner", {
                attrs: {
                  type: "dataset",
                  records: _vm.powerbi_dataset,
                  isForAllOwners: true,
                },
                on: {
                  submitDataset: _vm.assignAllOwner,
                  cancel: function ($event) {
                    return _vm.$bvModal.hide(_vm.MODAL_NAME_ALL_OWNER)
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }